import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Header from "../HeaderNew/component";
import HomeBanner from "./home-banner/index";
import ExcitingOffersSlider from "./exciting-offers-slider/index";
import ShopByCategoriesSlider from "./shop-by-categories-slider/index";
import TopGroceryStoresSlider from "./top-grocery-stores-slider/index";
import DealsOfTheDay from "./deals-of-the-day/index";
import BrandsInSpotlight from "./brands-in-spotlight/index";
import SectionHeading from "./section-heading/index";
import NearbyStores from "./near-by-store/index";
import { GET_CATEGORIES, GET_BUYER_APP_SETTINGS } from "../../api/apiList";
import API2 from "../../api/indexv2";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchSellers } from "../../slices/sellerSlice";
import Loader from "../../components/common/loader";
import Footer from "../../components/common/Footer";
import { Whatsapp } from "../../components/svgicons";
import "./styles.scss";
import "./home-new-styles.scss";
import "../HomePageNew/section-heading/section-heading.scss";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import Login from "../Login/component";
import DownArrowLightGreen from "../../images/home/down-arrow-light-green.svg";
import { Modal } from "reactstrap";
import YourAddress from "../YourAddress/component";
import { updateCartItem } from "../../slices/catalogSlice";
import { logoutUser } from "../../slices/userSlice";
import { notify } from "../../components/common/utils";
import PreloginAddress from "../ManageAddress/preloginaddress";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-creative";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCreative } from "swiper/modules";
import LogRocket from "logrocket";
import { setNavigator } from "../../api/navigation";
import MobileAddCart from "../../components/common/mobile-add-cart/index";
const HEADER_OFFSET = 80;

const HomePage = (props) => {
  const location = useLocation();
  const [categoriesData, setCategoriesData] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const searchParams = new URLSearchParams(location.search);
  const categoryParam = searchParams.get("category") || "All";
  const [offerImages, setOfferImages] = useState([]);
  const [dealImages, setDealImages] = useState([]);
  const [brandImages, setBrandImages] = useState([]);
  const [categoryImages, setCategoryImages] = useState([]);
  const defaultAddress = JSON.parse(localStorage.getItem("defaultAddress"));
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [showAllStores, setShowAllStores] = useState(false);
  const initialVisibleCount = 18;
  const sellers = useSelector((s) => s.sellers.sellers);
  const sellersStatus = useSelector((s) => s.sellers.sellersStatus);
  const recommendedSellers = useSelector((s) => s.sellers.recommendedSellers);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [showPreLoginAddessModal, setShowPreLoginAddessModal] = useState(false);
  const [YouraddressModal, setYourAddressModal] = useState(false);
  const [zipcode, setZipcode] = useState("");
  const [city, setCity] = useState("");
  const dispatch = useDispatch();
  const addressData = JSON.parse(localStorage.getItem("addressData"));
  let showNotify = true;
  const nearBySectionRef = useRef(null);
  const cartItems = useSelector((s) => s.catalog.cartItems);
  const [getCurrentLocationLoader, setGetCurrentLocationLoader] =
    useState(false);

  const handleGetCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          // setTempAddress({
          //   ...tempAddress,
          //   latitude: latitude,
          //   longitude: longitude,
          // });
          // const obj = { latitude, longitude };
          const defaultAddressT = {
            latitude: latitude,
            longitude: longitude,
            zipcode: defaultAddress?.zipcode || 0,
          };
          localStorage.setItem(
            "defaultAddress",
            JSON.stringify(defaultAddressT)
          );
          // getPlacesDetails(obj);
          // setOpenFromEdit(false);
          // setMap(true);
          // setSearchModal(false);
          // setGetCurrentLocationLoader(false);
        },
        (error) => {
          setGetCurrentLocationLoader(false);
          if (error.code === error.PERMISSION_DENIED) {
            notify(
              "error",
              "Allow location access in your browser to continue"
            );
          } else {
            notify(
              "error",
              "Error in facting your current location Try Again!"
            );
          }
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  };

  useEffect(() => {
    const getZipcodeFromAddress = () => {
      if (defaultAddress) {
        setZipcode(defaultAddress.zipcode);
        setCity(defaultAddress.address?.city);
      }
    };
    const addressData = JSON.parse(localStorage.getItem("addressData"));
    if (addressData && addressData?.zipcode) {
      setZipcode(addressData?.zipcode);
      setCity(addressData?.address.city);
    } else {
      getZipcodeFromAddress();
    }
  }, [addressData?.zipcode, defaultAddress]);

  useEffect(() => {
    localStorage.setItem("landingSource", `${process.env.REACT_APP_URL}`);
    getCategoriesData();
    setNavigator(navigate);
    if (user?.name && process.env.REACT_APP_NODE_ENV === "production") {
      LogRocket.identify(user?.userId, {
        name: user?.name,
        email: user?.email,
      });
    }
  }, []);

  useEffect(() => {
    if (location.state?.scrollTo === "nearBySection" && showNotify) {
      showNotify = false;
      notify("success", "Not all stores offer 30 min delivery");
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  useLayoutEffect(() => {
    if (location.state?.scrollTo === "nearBySection") {
      const scrollToSection = () => {
        if (nearBySectionRef.current) {
          const observer = new MutationObserver(() => {
            if (nearBySectionRef.current) {
              nearBySectionRef.current.scrollIntoView({ behavior: "smooth" });
              const top =
                nearBySectionRef.current.getBoundingClientRect().top +
                window.scrollY -
                HEADER_OFFSET;
              window.scrollTo({ top, behavior: "smooth" });
              observer.disconnect();
            }
          });
          observer.observe(document.body, { childList: true, subtree: true });
          return () => observer.disconnect();
        } else {
          requestAnimationFrame(scrollToSection); // wait until it’s mounted
        }
      };
      scrollToSection();
    }
  }, [location.pathname]);

  useEffect(() => {
    if (selectedCategory !== null) {
      getSellers();
    }
  }, [selectedCategory]);

  const getCategoriesData = async () => {
    try {
      const response = await API2.post(GET_CATEGORIES);
      if (response?.data?.data?.length) {
        const groceryCategories = response.data.data.find(
          (item) => item.title === "Grocery"
        );
        const allowedCategories = [
          "Fruits and Vegetables",
          "Masala & Seasoning",
          "Oil & Ghee",
          "Eggs, Meat & Fish",
          "Cleaning & Household",
          "Bakery, Cakes & Dairy",
          "Dairy and Cheese",
          "Snacks, Dry Fruits, Nuts",
          "Pasta, Soup and Noodles",
          "Sauces, Spreads and Dips",
          "Chocolates and Biscuits",
          "Atta, Flours and Sooji",
          "Rice and Rice Products",
          "Dals and Pulses",
          "Energy and Soft Drinks",
          "Tea and Coffee",
          "Fruit Juices and Fruit Drinks",
          "Snacks and Namkeen",
          "Ready to Cook and Eat",
          "Pickles and Chutney",
          "Frozen Snacks",
        ];
        const filteredCategories = groceryCategories.subCategories.filter(
          (category) => allowedCategories.includes(category.title)
        );
        setCategoriesData(filteredCategories);
        setSelectedCategory("Grocery");
      } else {
        console.error("No data returned from API");
      }
    } catch (error) {
      console.log("ERROR CATEGORIES: ", error);
    }
  };

  const getSellers = async () => {
    try {
      dispatch(
        fetchSellers({
          areaCode: defaultAddress?.zipcode,
          category: selectedCategory?.title,
          userId: user?._id,
          longitude: defaultAddress?.longitude,
          latitude: defaultAddress?.latitude,
        })
      );
    } catch (error) {
      console.log("ERROR FETCH SELLER ", error);
    }
  };

  useEffect(() => {
    const fetchOfferImages = async () => {
      try {
        const res = await API2.get(GET_BUYER_APP_SETTINGS);
        if (res?.data) {
          setOfferImages(res.data?.offerImages);
          setDealImages(res.data?.dealoftheday);
          setBrandImages(res.data?.brands);
          setCategoryImages(res?.data?.newCategories);
        }
      } catch (error) {
        console.error("ERROR BuyerAPPSettings: ", error);
      } finally {
      }
    };
    fetchOfferImages();
  }, []);

  const handleViewMore = () => {
    setShowAllStores(true);
  };

  const sellersToDisplay = showAllStores
    ? sellers
    : sellers.slice(0, initialVisibleCount);

  const generateWhatsAppUrl = (phoneNumber, message) => {
    return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  };

  const handleWhatsAppButtonClick = (phoneNumber, message) => {
    const whatsappUrl = generateWhatsAppUrl(phoneNumber, message);
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };
  const userLogout = () => {
    dispatch(updateCartItem([]));
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("cart");
    localStorage.removeItem("sellerDetails");
    localStorage.removeItem("slug");
    if (defaultAddress?.address) {
      delete defaultAddress?.address;
      localStorage.setItem("defaultAddress", JSON.stringify(defaultAddress));
    }
    dispatch(logoutUser());
    navigate("/");
  };

  return (
    <>
      {process.env.REACT_APP_NODE_ENV === "production" &&
        localStorage.getItem("landingSource")?.includes("qc") && (
          <Helmet>
            <script>
              {`!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '326242339368504');
          fbq('track', 'PageView');`}
            </script>
            <noscript>
              {`<img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=326242339368504&ev=PageView&noscript=1"/>`}
            </noscript>
          </Helmet>
        )}
      {showPreLoginAddessModal && (
        <PreloginAddress
          {...props}
          showPreLoginAddessModal={showPreLoginAddessModal}
          setShowPreLoginAddessModal={setShowPreLoginAddessModal}
        ></PreloginAddress>
      )}
      <Modal
        isOpen={YouraddressModal}
        size="lg"
        toggle={() => setYourAddressModal(false)}
        className="custom-modal-kl"
      >
        <YourAddress
          setZipcode={setZipcode}
          setYourAddressModal={setYourAddressModal}
        />
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <ToastContainer />
      {categoriesData === null ? (
        <div className="dotLoader">
          <Loader />
        </div>
      ) : (
        <>
          <Header />
          <>
            {sellersStatus === "loaded" ? (
              <>
                <div className="mobile-secondary-header-kl mobile-secondary-header-home-kl">
                  <div className="mobile-secondary-header-inner-kl">
                    <div
                      className="buyer-pin-code-mobile-kl"
                      onClick={() => {
                        const userId = JSON.parse(localStorage.getItem("user"));
                        if (!user) {
                          setShowPreLoginAddessModal(true);
                        } else if (userId) {
                          setYourAddressModal(true);
                        } else {
                          userLogout();
                          notify(
                            "error",
                            "Session expired. Please log in first!"
                          );
                        }
                      }}
                    >
                      {zipcode && zipcode.length !== 0 && (
                        <div className="buyer-pin-number-mobile-kl">
                          {`${city ? city + " -" : ""}`} {zipcode}
                          <img
                            className="down-arrow-kl"
                            src={DownArrowLightGreen}
                            alt=""
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="home-page-container-kl">
                  <HomeBanner />
                  <div className="category-my-carousel">
                    <div
                      onClick={() => {
                        const userId = JSON.parse(localStorage.getItem("user"));
                        if (!user) {
                          handleGetCurrentLocation();
                          setShowPreLoginAddessModal(true);
                        } else if (userId) {
                          setYourAddressModal(true);
                        } else {
                          userLogout();
                          notify(
                            "error",
                            "Session expired. Please log in first!"
                          );
                        }
                      }}
                    ></div>
                    <Swiper
                      modules={[Navigation, EffectCreative]}
                      className="circular-slider"
                      loop={true}
                      grabCursor={true}
                      centeredSlides={true}
                      slidesPerView={3}
                      effect="creative"
                      creativeEffect={{
                        perspective: true,
                        limitProgress: 3,
                        prev: {
                          translate: ["-100%", "-35%", -180],
                          rotate: [0, 0, -0],
                          origin: "top",
                        },
                        next: {
                          translate: ["100%", "-35%", -180],
                          rotate: [0, 0, 0],
                          origin: "top",
                        },
                      }}
                    >
                      {categoriesData.map((category, index) => (
                        <SwiperSlide key={index}>
                          <div
                            onClick={() => {
                              const encodedValue = encodeURIComponent(
                                category?.title
                              );
                              navigate(`/category?name=${encodedValue}`);
                            }}
                            className="category-slide"
                          >
                            <div className="category-image-wrapper">
                              <img
                                src={category.imgUrl}
                                alt={category.title}
                                className="category-image"
                              />
                            </div>
                            <span className="category-name">
                              {category.title}
                            </span>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                  {offerImages?.length > 0 && (
                    <section>
                      <SectionHeading title="Exciting Offers" showAll={false} />
                      <ExcitingOffersSlider
                        offerImages={offerImages}
                        navigate={navigate}
                      />
                    </section>
                  )}
                  {categoryImages?.length > 0 && (
                    <section className="desktop-only">
                      <SectionHeading
                        title="Shop By Categories"
                        showAll={false}
                      />
                      <ShopByCategoriesSlider
                        categoryImages={categoryImages}
                        navigate={navigate}
                      />
                    </section>
                  )}
                  {recommendedSellers?.length > 0 && (
                    <section>
                      <SectionHeading
                        title="Top Grocery Stores"
                        showAll={sellersToDisplay?.length > 6}
                        navigate={navigate}
                        recommendedSellers={sellersToDisplay}
                        categoryParam={categoryParam}
                      />
                      <TopGroceryStoresSlider
                        recommendedSellers={sellersToDisplay}
                        navigate={navigate}
                        categoryParam={categoryParam}
                      />
                    </section>
                  )}
                  {dealImages?.length > 0 && (
                    <section>
                      <SectionHeading
                        title="Deals Of The Day"
                        showAll={false}
                      />
                      <DealsOfTheDay
                        dealImages={dealImages}
                        navigate={navigate}
                      />
                    </section>
                  )}
                  {brandImages?.length > 0 && (
                    <section>
                      <SectionHeading
                        title="Brands In Spotlight"
                        showAll={false}
                      />
                      <BrandsInSpotlight
                        brandImages={brandImages}
                        navigate={navigate}
                      />
                    </section>
                  )}
                  <section ref={nearBySectionRef}>
                    <SectionHeading
                      title="Stores Near Your Location"
                      showAll={false}
                    />
                    <NearbyStores
                      sellers={sellersToDisplay}
                      navigate={navigate}
                      categoryParam={categoryParam}
                    />
                    {sellers?.length > 18 && !showAllStores && (
                      <div className="container mt-4">
                        <div className="row">
                          <div className="col-12 text-center">
                            <div className="view-more-container-kl">
                              <button
                                onClick={handleViewMore}
                                className="view-more-product-btn-kl"
                              >
                                View More
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </section>
                </div>

                <div className="contact_section-kl">
                  <div
                    className="zoom-in-out-box-kl "
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => {
                      handleWhatsAppButtonClick(
                        "+918108211231",
                        "Hey! I need a help on kikoshop.in"
                      );
                    }}
                  >
                    <Whatsapp />
                  </div>
                </div>
                <Footer />
              </>
            ) : (
              <Loader />
            )}
          </>
          {modalIsOpen && (
            <Login
              isOpenFromCart={false}
              modalIsOpen={modalIsOpen}
              setModalIsOpen={setModalIsOpen}
            ></Login>
          )}
        </>
      )}
      <MobileAddCart itemCount={cartItems?.length} />
    </>
  );
};

export default HomePage;
